import { HeadGoverness } from 'vue-kindergarten';
import { ROUTES } from '../../plugins/types';
/**
 * @module Governess/RouteGoverness
 * @description Main Governess for routing
 * */
export default class RouteGoverness extends HeadGoverness {
    constructor (from, to, next, store) {
        super({from, to, next});

        this.next = next;
        this.from = from;
        this.to = to;
        this.store = store;
    }

    /**
     * @function guard
     * @param {String} action - Type of action user wants to perform, eg. 'read', 'update'
     * @description guards routes from unauthorized access and redirects unauthorized users to proper route or to
     * Unauthorized screen
     * */
    guard (action, {from, to, next}) {
        if (super.isNotAllowed(action)) {
            this.redirectTo(ROUTES.LOGIN);
        } else {
            next();
        }
    }
    /**
     * @function redirectTo
     * @param {String} routeName - name of redirection route
     * @description redirects unauthorized user to given route name
     * */
    redirectTo (routeName) {
        this.store.dispatch('setBack', this.to);
        this.next({
            name: routeName
        });
    }
}
